import { render, staticRenderFns } from "./ExamCreation.vue?vue&type=template&id=2330e0be"
import script from "./ExamCreation.vue?vue&type=script&lang=js"
export * from "./ExamCreation.vue?vue&type=script&lang=js"
import style0 from "./ExamCreation.vue?vue&type=style&index=0&id=2330e0be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports